export enum Experiment {
  ShowTranslationKeys = 'specs.cashier.ShowTranslationKeys',
  EnableSandboxTestMode = 'specs.EnableSandboxTestMode',
  EnableSeamlessOnboardingOnProvisioningSpec = 'specs.cashier.settings.EnableSeamlessOnboardingOnProvisioningSpec',
  EnablePayPalCreditCheckbox = 'specs.cashier.EnablePayPalCreditCheckbox',
  DisablePayPalSmartOnboardingSpec = 'specs.DisablePayPalSmartOnboardingSpec',
  EnableSmartlingContextCapture = 'specs.payments.EnableSmartlingContextCapture',
  EnableSmartlingCaptureContext = 'specs.smartling.CaptureContext',
  EnableWixPayCardReaderMerchantSpec = 'specs.EnableWixPayCardReaderMerchantSpec',
  ShouldPreferStripeToWixPaymentsSpec = 'specs.ShouldPreferStripeToWixPaymentsSpec',
  HideKYCForWixPaymentsStripeUsers = 'specs.payments.HideKYCForWixPaymentsStripeUsers',
  ShowDynamicPricingForWixPayments = 'specs.payments.ShowDynamicPricingForWixPayments',
  HidePlatformProvidersInUSOnboarding = 'specs.payments.HidePlatformProvidersInUSOnboarding',
  DisableWPLinksForNonOwner = 'specs.payments.DisableWPLinksForNonOwner',
  EnableCBDModalV2 = 'specs.payments.EnableCBDModalV2',
  EnableRestrictedGoodsPageV2 = 'specs.payments.EnableRestrictedGoodsPageV2',
  BoletoUnderWixPayPhase2 = 'specs.payments.BoletoUnderWixPayPhase2',
  HotelsRedirectToCashierInBO = 'specs.hotels.RedirectToCashierInBO',
  ShouldCheckForCbdFlow = 'specs.ShouldCheckForCbdFlow',
  ShowMakeSureToEnableStripeMethod = 'specs.payments.ShowMakeSureToEnableStripeMethod',
  ShowWPTestModeWarning = 'specs.payments.ShowWPTestModeWarning',
  FastSupportAccessPhase1 = 'specs.payments.FastSupportAccessPhase1',
  HidePinwheelInOldUSOnboarding = 'specs.payments.HidePinwheelInOldUSOnboarding',
  ConnectStripeOverAdyenSpec = 'specs.ConnectStripeOverAdyenSpec',
  ConnectStripeOverAdyenPOSOnlySpec = 'specs.ConnectStripeOverAdyenPOSOnlySpec',
  ConnectStripeOverAdyenGBSpec = 'specs.ConnectStripeOverAdyenGBSpec',
  ConnectStripeOverAdyenESSpec = 'specs.ConnectStripeOverAdyenESSpec',
  ConnectStripeOverAdyenFISpec = 'specs.ConnectStripeOverAdyenFISpec',
  ConnectStripeOverAdyenIESpec = 'specs.ConnectStripeOverAdyenIESpec',
  ConnectStripeOverAdyenITSpec = 'specs.ConnectStripeOverAdyenITSpec',
  ConnectStripeOverAdyenPTSpec = 'specs.ConnectStripeOverAdyenPTSpec',
  ConnectStripeOverAdyenLTSpec = 'specs.ConnectStripeOverAdyenLTSpec',
  EnableAcceptPaymentRedesign2020v4 = 'specs.payments.EnableAcceptPaymentRedesign2020v4',
  ForceDataCapsuleLocalStorageInOnboarding = 'specs.payments.ForceDataCapsuleLocalStorageInOnboarding',
  ErrorMessagesBlitz = 'specs.payments.ErrorMessagesBlitz',
  EnableWixPayCACreditCardMerchantSpec = 'specs.EnableWixPayCACreditCardMerchantSpec',
  EnableWpPlatformizedUI = 'specs.payments.EnableWpPlatformizedUI',
  ShouldShowWpToPartnersSpec = 'specs.ShouldShowWpToPartnersSpec',
  UseNewFlags = 'specs.payments.UseNewFlags',
}
